import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "value",
      description: "是否折叠",
      type: "Boolean"
    },
    {
      prop: "duration",
      description: "折叠时间",
      type: "Number",
      default: "0.3"
    },
    {
      prop: "timingFunction",
      description: "折叠动画函数, 参考css transition的ease属性",
      type: "String",
      default: "ease-in-out"
    }
  ],
  events: [],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
